









































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import moment from 'moment';
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBox.vue";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import RecogSidebar from "../../components/RecogSidebar.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue"
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import axios, { CancelTokenSource } from 'axios';
import { BModal, BCarousel, BPopover } from 'bootstrap-vue';
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import { Sheet, SheetField, FieldActivity, ParamFieldActivity, TensakuText } from "../../modules/teacher/SaitenInput";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  scale: number
  fieldPadding: number
  fieldMargin: number
  fieldWrapWidth: number
  fieldWrapHeight: number
  fieldImageWidth: number
  fieldImageHeight: number
  windowHeight: number
  drawMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  base64CorrectImage: string
  tensakuText: string
  tensakuFontSize: number
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isProcessingApi: boolean
  isUpdateConfirmed: boolean
  tensakuNumberOptions: any[]
  fontSizeOptions: any[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  timer: any
  keyCode: string
  errors: string[]
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  isDispCorrectImage: boolean
  correctImageScale: number
  scrollBarSize: number
  correctImageMarginTop: number
  isLoaded: boolean
  examineeIds: number[]
  isScanImageVisible: boolean
  previewScanImageExamineeId: number
  is_first_room: boolean
  is_last_room: boolean
  isShowSessionMsg: boolean
  isWarningTimeReached: boolean
  warningDispTime: number
  fontSize: number
  lineHeight: number
  textColor: string
  selectedTensakuText: TensakuText
  drawColor: string
  isRecogSidebarVisible: boolean
  isRecogOverlay: boolean
  cancelToken: CancelTokenSource
  copiedStamp: any
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
    "text-edit-box": TextEditBox,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "preview-image-sidebar": PreviewImageSidebar,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
    "recog-sidebar": RecogSidebar,
  },
  setup(props, context){

    const DrawModeEnum = Common.DrawModeEnum;
    const SaitenSortKindEnum = Common.SaitenSortKindEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;
    const DirectionEnum = Common.DirectionEnum;
    const SheetTypeEnum = Common.SheetTypeEnum;

    const saitenBoxRef = ref([]);
    const modalCorrectImageRef = ref<InstanceType<typeof BModal>>();
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const popoverNumTextRef = ref<InstanceType<typeof BPopover>>();
    const previewImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();
    const recogSidebarRef = ref<InstanceType<typeof RecogSidebar>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      scale: 0,
      fieldPadding: 8,
      fieldMargin: 5,
      fieldWrapWidth: 0,
      fieldWrapHeight: 0,
      fieldImageWidth: 0,
      fieldImageHeight: 0,
      windowHeight: 0,
      drawMode: DrawModeEnum.KeyInput,
      sortKind: SaitenSortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      base64CorrectImage: "",
      tensakuText: "1",
      tensakuFontSize: 30,
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isProcessingApi: false,
      tensakuNumberOptions: new Array<object>(),
      fontSizeOptions: new Array<object>(),
      pcHelpFields: [
        { key: "O・Aキー", img: [require("@/assets/images/keyboard_A.png"), require("@/assets/images/keyboard_O.png")], description: "正答○（KEY入力モードのみ有効）" },
        { key: "X・Fキー", img: [require("@/assets/images/keyboard_F.png"), require("@/assets/images/keyboard_X.png")], description: "誤答✕（KEY入力モードのみ有効）" },
        { key: "1-9キー", img: [require("@/assets/images/keyboard_1.png")], description: "△得点（KEY入力モードのみ有効）" },
        { key: "Pキー", img: [require("@/assets/images/keyboard_P.png")], description: "一括正答（未採点分をすべて○）" },
        { key: "Zキー", img: [require("@/assets/images/keyboard_Z.png")], description: "一括誤答（未採点分をすべて✕）" },
        { key: "BackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の切出しの採点内容をクリア" },
        { key: "テキスト選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中のテキストを削除" },
        { key: "エンターキー", img: [require("@/assets/images/keyboard_Enter.png")], description: "採点内容を保存して次の設問へ移動" },
        { key: "Mキー", img: [require("@/assets/images/keyboard_M.png")], description: "採点内容を保存して次の設問へ移動" },
        { key: "Hキー", img: [require("@/assets/images/keyboard_H.png")], description: "保存して戻る" },
        { key: "Wキー", img: [require("@/assets/images/keyboard_W.png")], description: "模範解答画像を表示" },
        { key: "Gキー", img: [require("@/assets/images/keyboard_G.png")], description: "拡大" },
        { key: "Qキー", img: [require("@/assets/images/keyboard_Q.png")], description: "縮小" },
        { key: "矢印キー", img: [require("@/assets/images/keyboard_Arrow.png")], description: "矢印の方向の切出し画像へ選択を変更" },
        { key: "Dキー + マウス", img: [require("@/assets/images/keyboard_D.png")], description: "自由線" },
        { key: "Eキー + マウス", img: [require("@/assets/images/keyboard_E.png")], description: "消しゴム" },
        { key: "Tキー + マウス", img: [require("@/assets/images/keyboard_T.png")], description: "テキスト" },
      ],
      tabletHelpFields: [
        { key: "右方向", img: require("@/assets/images/flick_right.png"), description: "正答○" },
        { key: "左方向", img: require("@/assets/images/flick_left.png"), description: "誤答✕" },
        { key: "下方向", img: require("@/assets/images/flick_down.png"), description: "△の横の得点" },
        { key: "画像上を長押し", img: null, description: "長押しした箇所にテキストを表示" },
        { key: "テキストを長押し", img: null, description: "テキストを削除" },
        { key: "", img: [require("@/assets/images/keyboard_SaitenInputModeArea.png")], description: "KEY入力モード以外のメニューボタンがON（緑色）になっている場合は、<font style='color:red'>長押し操作が反映されません。</font><br>ON（緑色）のアイコンを押すと、OFF（グレー）に戻ります。" },
      ],
      timer: null,
      keyCode: "",
      errors: [],
      direction: Common.DirectionEnum.Horizon,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.3,
      horizonBottomHeightPer: 0.7,
      verticalLeftWidthPer: 0.2,
      verticalRightWidthPer: 0.8,
      separatorSize: 10,
      isDispCorrectImage: true,
      correctImageScale: 50,
      scrollBarSize: 0,
      correctImageMarginTop: 15,
      isLoaded: false,
      examineeIds: [],
      isScanImageVisible: false,
      previewScanImageExamineeId: null,
      is_first_room: false,
      is_last_room: false,
      isShowSessionMsg: false,
      isWarningTimeReached: false,
      warningDispTime: 9999999,
      drawColor: "#FF0000",
      fontSize: 20,
      lineHeight: 0,
      textColor: "#FF0000",
      selectedTensakuText: null,
      isRecogSidebarVisible: false,
      isRecogOverlay: false,
      cancelToken: null,
      copiedStamp: null,
    });

    /************************************************************
     * 選択中のfieldActivity
     ************************************************************/
    const selectedFieldActivity = computed((): FieldActivity | null => {
      const idx = state.selectedIdx;
      if(idx == null || idx < 0 || idx >= state.fieldActivities.length){
        return null;
      }
      return state.fieldActivities[idx];
    });

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedTensakuTextElemId = computed((): any => {
      if(!state.selectedTensakuText || state.selectedIdx == null){
        return null;
      }else{
        return `saiten-box-${state.selectedIdx}-${state.direction}`;
        // return `text-image-${state.direction}-${selectedFieldActivity.value?.id}-${state.selectedTensakuText.idx}`;
      }
    });

    /************************************************************
     * 選択中のテキストスタンプ切り替え SaitenBoxから呼ばれる
     ************************************************************/

    const changeSelectedTensakuText = (tensakuText: TensakuText) => {
      state.selectedTensakuText = tensakuText;
      if(state.selectedTensakuText){
        state.fontSize = tensakuText.font_size;
        state.lineHeight = tensakuText.line_height;
        state.textColor = tensakuText.color;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedTensakuText.text, fontSize: state.selectedTensakuText.font_size, lineHeight: state.selectedTensakuText.line_height, direction: state.selectedTensakuText.direction, defaultText: "テキスト"});
      
      if(state.selectedTensakuText.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedTensakuText.width;
        state.selectedTensakuText.x -= diffW;
      }

      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText, "テキスト");
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedTensakuText.font_size = state.fontSize;
      state.selectedTensakuText.line_height = state.lineHeight;
      state.selectedTensakuText.color = state.textColor;
      const size = Common.getTextSize({text: state.selectedTensakuText.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.selectedTensakuText.direction, defaultText: "テキスト"});
      
      if(state.selectedTensakuText.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedTensakuText.width;
        state.selectedTensakuText.x -= diffW;
      }
      
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText, "テキスト");
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削テキストスタンプ追加
     ************************************************************/

    const addTensakuText = (param: any) => {
      const size = Common.getTextSize({text: "", fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection, defaultText: "テキスト"});
      const tensakuText = new TensakuText();
      tensakuText.text = ""
      const fieldActivity = selectedFieldActivity.value;
      if(!fieldActivity){
        return;
      }
      tensakuText.field_activity_id = fieldActivity.id;
      tensakuText.idx = fieldActivity.tensakuTextIdx++;
      tensakuText.font_size = state.fontSize;
      tensakuText.line_height = 0;
      tensakuText.color = state.textColor;
      tensakuText.x = param.point.x;
      tensakuText.y = param.point.y;
      tensakuText.width = size.width;
      tensakuText.height = size.height;
      tensakuText.direction = context.root.$store.state.textDirection;
      tensakuText.base64_text = Common.createBase64Text(tensakuText, "テキスト");
      fieldActivity.tensakuTexts.push(tensakuText);
      state.selectedTensakuText = tensakuText;
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteTensakuText = (fieldActivityIdx: number, tensakuTextIdx: number) => {
      state.fieldActivities[fieldActivityIdx].tensakuTexts.splice(tensakuTextIdx, 1);
      state.selectedTensakuText = null;
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
      adjustLayout();
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
      adjustLayout();
    }

    /************************************************************
     * 採点エリアwidth
     ************************************************************/

    const saitenBoxAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalRightWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 採点エリアheight
     ************************************************************/

    const saitenBoxAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.correctImageMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonBottomHeightPer - state.scrollBarSize - state.correctImageMarginTop
      }
    });

    /************************************************************
     * 模範解答エリアwidth
     ************************************************************/

    const correctImageAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalLeftWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 模範解答エリアheight
     ************************************************************/

    const correctImageAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.correctImageMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonTopHeightPer - state.scrollBarSize - state.correctImageMarginTop
      }
    });

    /************************************************************
     * 模範解答エリア倍率設定
     ************************************************************/

    const setCorrectImageScale = () => {
      const scaleW = (correctImageAreaWidth.value) / (state.currentSheetField.baseWidth);
      const scaleH = (correctImageAreaHeight.value) / (state.currentSheetField.baseHeight);
      state.correctImageScale = (scaleW > scaleH ? scaleH : scaleW) * 100;
    }

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        adjustLayout();
        setCorrectImageScale();
      }
    }

    /************************************************************
     * 模範解答imgタグのCSS
     ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.currentSheetField.baseWidth * state.correctImageScale / 100}px`;
      style["height"] = `${state.currentSheetField.baseHeight * state.correctImageScale / 100}px`;
      style["margin-top"] = `15px`;
      style["padding-left"] = `8px`;
      style["padding-right"] = `8px`;
      style["padding-bottom"] = `8px`;
      return style;
    });

    /************************************************************
     * ショートカットキー使用可否判定
     ************************************************************/

    const isShortcutEditable = computed((): any => {
      return !state.isProcessingApi && !context.root.$store.state.isShowingMsgBox;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const imageArea = document.getElementById("image-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        state.mainAreaHeight = windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight;
        state.mainAreaWidth = windowWidth;
        imageArea.style.height = `${state.mainAreaHeight}px`;
      }
      
      // 画像1件あたりの縦横サイズを整形
      state.fieldWrapWidth = (saitenBoxAreaWidth.value - 20) / state.colCount - (state.fieldMargin * 2);
      state.fieldImageWidth = state.fieldWrapWidth - (state.fieldPadding * 2);
      state.scale = state.fieldImageWidth / (state.currentSheetField.baseWidth);
      state.fieldImageHeight = Math.round((state.currentSheetField.baseHeight) * state.scale);
      state.fieldWrapHeight = state.fieldImageHeight + state.fieldPadding * 2;

      setCorrectImageScale();
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const showModalCorrectImage = () => {
      blur();
      state.isDispCorrectImage = !state.isDispCorrectImage;
      adjustLayout();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (examineeId: number) => {
      blur();

      state.previewScanImageExamineeId = examineeId;
      state.isScanImageVisible = true;
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number) => {
      blur();
      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if(sortKind == SaitenSortKindEnum.No){
        state.fieldActivities.sort((a, b) => a.sortNo - b.sortNo);
      }else if(sortKind == SaitenSortKindEnum.CorrectState){
        state.fieldActivities.sort((a, b) => {
          if(a.score != b.score){
            return (a.score - b.score) * -1;
          }
          return a.sortNo - b.sortNo;
        });
      }else{
        state.fieldActivities.sort((a, b) => {
          if(a.base64Image.length != b.base64Image.length){
            return (a.base64Image.length - b.base64Image.length) * -1;
          }
          return a.sortNo - b.sortNo;
        });
      }

      state.examineeIds = state.fieldActivities.map(x => x.examinee.id);
    };

    /************************************************************
     * 拡大・縮小
     ************************************************************/

    const changeColCount = (addValue: number) => {
      blur();
      if(state.colCount + addValue <= 0){
        return;
      }

      state.colCount += addValue;
      state.isColCountChanged = true;
      adjustLayout();
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeSaitenMode = (drawMode: number) => {
      blur();
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }

      popoverNumTextRef.value.$emit("close");

      if(state.drawMode == DrawModeEnum.Number){
        popoverNumTextRef.value.$emit("open");
      }
    }

    /************************************************************
     * 採点BOXからのemitによる採点モード切り替え
     ************************************************************/

    const changeSaitenModeBySaitenBox = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyUp = (e:KeyboardEvent) => {
      state.keyCode = "";

      if(e.key == "e" || e.key == "d"){
        // 現在描画中のcanvasを保持
        saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
          if(x.idx == state.selectedIdx){
            x.resetDrawingByKeyUp();
          }
        });
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyDown = async (e: KeyboardEvent) => {

      if(e.key == "e" || e.key == "d" || e.key == "e" || e.key == "d" || e.key == "t"){
        state.keyCode = e.key;
      }

      // API通信中は処理しない
      if(!isShortcutEditable.value){
        return;
      }

      // 認識サイドバー表示中は模範解答表示以外は処理しない
      if(state.isRecogSidebarVisible){
        if(e.key == "w" && !context.root.$store.getters.isHomework){
          recogSidebarRef.value.isDispCorrectImage = !recogSidebarRef.value.isDispCorrectImage;
        }
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      e.preventDefault();

      if(["o", "a", "x", "f", "y", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
        
        // キー入力モード以外は処理しない
        if(state.drawMode != DrawModeEnum.KeyInput){
          return;
        }

        if(e.key == "o" || e.key == "a"){
          // Oキー Aキー 正答
          setCorrect(CorrectStateEnum.Seitou, state.currentSheetField.allot);
        }else if(e.key == "x" || e.key == "f"){
          // Xキー Fキー 誤答
          setCorrect(CorrectStateEnum.Gotou, 0);
        }else if(e.key == "y"){
          // Yキー 部分点 部分点入力不可の場合は処理終了
          if(state.isTokutenModeDisabled){
            return;
          }
          setCorrect(CorrectStateEnum.Tokuten, state.selectedScore);
        }else if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
          // 数字キー1〜9押下で部分点
          const score = Number(e.key);
          if(score < state.currentSheetField.allot){
            setCorrect(CorrectStateEnum.Tokuten, score);
          }else{
            // 部分点が配点の範囲外の場合は処理終了
            return;
          }
        }

        if(state.selectedIdx + 1 == state.fieldActivities.length){
          if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
            setTimeout(async () => {
              // 次の設問へ
              if(state.next_sheet_field != null){          
                toNextField();
              }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, "最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
                sendSaitenData(null, null);
              }
            }, 100);
          }
        }else{
          state.selectedIdx++;
          const prevSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx - 1}-${state.direction}`);
          const nextSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx}-${state.direction}`);
          if(prevSaitenBox.offsetTop != nextSaitenBox.offsetTop){
            const imageArea = document.getElementById("saiten-box-area");
            const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
            const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
            Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
          }
        }
      }else if(e.key == "Enter"){
        // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
        if(modalCorrectImageRef.value.$data.isShow){
          modalCorrectImageRef.value.hide();
        }else if(modalAddtionRef.value.$data.isShow){
          modalAddtionRef.value.hide();
        }else{
          // 次の設問へ
          if(state.next_sheet_field != null){          
            await toNextField();
          }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, "最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
            sendSaitenData(null, null);
          }
        }
      }else if(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(e.key) != -1){
        
        const nowIdx = state.selectedIdx;
        let nextIdx = -1;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の設問へ
          nextIdx = state.selectedIdx - 1;
        }else if(e.key == "ArrowRight"){
          // 右矢印 次の設問へ
          nextIdx =  state.selectedIdx + 1;
        }else{
          const row = Math.floor(state.selectedIdx / state.colCount);
          const col = state.selectedIdx % state.colCount;
          if(e.key == "ArrowUp"){
            // 上矢印 上の行の設問へ
            nextIdx = ((row - 1) * state.colCount) + col;
          }else if(e.key == "ArrowDown"){
            // 下矢印 下の行の設問へ
            nextIdx = ((row + 1) * state.colCount) + col;
          }
        }

        // インデックスが範囲外の場合は処理終了
        if(nextIdx < 0 || nextIdx + 1 > state.fieldActivities.length){
          return;
        }

        state.selectedIdx = nextIdx;
        const nowSaitenBox = document.getElementById(`saiten-box-${nowIdx}-${state.direction}`);
        const nextSaitenBox = document.getElementById(`saiten-box-${nextIdx}-${state.direction}`);
        if(nowSaitenBox.offsetTop != nextSaitenBox.offsetTop){
          const imageArea = document.getElementById("saiten-box-area");
          const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
          const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
          Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
        }

      }else if(e.key == "w"){
        // Wキー 模範解答の表示・非表示切り替え
        state.isDispCorrectImage = !state.isDispCorrectImage;
        context.root.$nextTick(() => {
          adjustLayout();
        });
      }else if(e.key == "p"){
        // Pキー 一括正答採点
        allCorrectChange(CorrectStateEnum.Seitou);
      }else if(e.key == "z"){
        // Zキー 一括誤答採点
        allCorrectChange(CorrectStateEnum.Gotou);
      }else if(e.key == "m"){
        if(state.next_sheet_field != null){          
          toNextField();
        }
      }else if(e.key == "Backspace"){
        const fieldActivity = selectedFieldActivity.value;
        if(!fieldActivity){
          return;
        }
        if(state.selectedTensakuText){
          const idx = fieldActivity.tensakuTexts.indexOf(state.selectedTensakuText);
          deleteTensakuText(state.selectedIdx, idx);
          fieldActivity.isTextEdited = true;
        }else{
          // TODO 公開済みの場合は確認メッセージ
          // if(context.root.$store.getters.isEntranceOrPractice && state.currentSheet.approval_flg){
          //   await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
          //   return;
          // }
          fieldActivity.correct_state = null;
          fieldActivity.score = null;
          // 選択中の切り出しのcanvasをクリア
          saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
            if(x.idx == state.selectedIdx){
              x.clearCanvas();
            }
          });
        }
      }else if(e.key == "q"){
        // Qキー 縮小
        changeColCount(1);
      }else if(e.key == "g"){
        // Gキー 拡大
        changeColCount(-1);
      }else if(e.key == "h"){
        // Hキー 保存して戻る
        toSaitenListWithSendSaitenData();
      }else if(e.key == "c" && e.ctrlKey){
        if(state.selectedTensakuText){
          // テキストスタンプコピー
          const copiedStamp = new TensakuText();
          copiedStamp.text = state.selectedTensakuText.text;
          copiedStamp.font_size = state.selectedTensakuText.font_size;
          copiedStamp.line_height = state.selectedTensakuText.line_height;
          copiedStamp.color = state.selectedTensakuText.color;
          copiedStamp.x = state.selectedTensakuText.x;
          copiedStamp.y = state.selectedTensakuText.y;
          copiedStamp.width = state.selectedTensakuText.width;
          copiedStamp.height = state.selectedTensakuText.height;
          copiedStamp.direction = state.selectedTensakuText.direction;
          copiedStamp.base64_text = state.selectedTensakuText.base64_text;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "添削テキストをコピーしました。");
        }
      }else if(e.key == "v" && e.ctrlKey && state.copiedStamp != null && selectedFieldActivity.value){
        if(state.copiedStamp instanceof TensakuText){
          // テキストスタンプペースト(参照を切るために一旦json化して別インスタンスとしてペースト)
          const pasteStamp = JSON.parse(JSON.stringify(state.copiedStamp)) as TensakuText;
          pasteStamp.field_activity_id = selectedFieldActivity.value.id;
          pasteStamp.idx = selectedFieldActivity.value.tensakuTextIdx++;
          selectedFieldActivity.value.tensakuTexts.push(pasteStamp);
          state.selectedTensakuText = pasteStamp;
          selectedFieldActivity.value.isTextEdited = true;
          Common.showToast(context.root.$bvToast, "添削テキストをペーストしました。");
        }
      }
    };

    /************************************************************
     * 選択行移動
     ************************************************************/

    const changeRow = (addCnt: number) => {
      const row = Math.floor(state.selectedIdx / state.colCount);
      const col = state.selectedIdx % state.colCount;

      const nowIdx = state.selectedIdx;
      const nextIdx = ((row + addCnt) * state.colCount) + col;

      // インデックスが範囲外の場合は処理終了
      if(nextIdx < 0 || nextIdx + 1 > state.fieldActivities.length){
        return;
      }

      state.selectedIdx = nextIdx;
      scrollSaitenBoxArea(nowIdx, nextIdx);
    }

    /************************************************************
     * 切出しエリアスクロール
     ************************************************************/

    const scrollSaitenBoxArea = (nowIdx: number, nextIdx: number) => {
      const nowSaitenBox = document.getElementById(`saiten-box-${nowIdx}-${state.direction}`);
      const nextSaitenBox = document.getElementById(`saiten-box-${nextIdx}-${state.direction}`);
      if(nowSaitenBox.offsetTop != nextSaitenBox.offsetTop){
        const imageArea = document.getElementById("saiten-box-area");
        const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
        const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
        Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
      }
    }

    /************************************************************
     * 採点内容変更
     ************************************************************/

    const setCorrect = (correctState: number, score: number) => {
      const fieldActivity = selectedFieldActivity.value;
      if(!fieldActivity){
        return;
      }
      fieldActivity.correct_state = correctState;
      fieldActivity.score = score;
    }

    /************************************************************
     * 一括採点ボタン押下
     ************************************************************/

    const allCorrectChange = async (correctState: number) => {

      blur();

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未採点項目の採点内容を一括で変更します。よろしいですか？")){
        return;
      }

      state.fieldActivities.filter(x => x.correct_state == null).forEach(x => {
        x.correct_state = correctState;
        if(correctState == CorrectStateEnum.Seitou){
          x.score = state.currentSheetField.allot;
        }else{ 
          x.score = 0;
        }
      });
    };

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrect = async () => {
      blur();
      if(!window.confirm("採点内容を画面表示時点の状態にクリアします。よろしいですか？")){
        return;
      }
      window.location.reload();
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = () => {
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "採点内容を保存して採点一覧に戻ります。よろしいですか？")){
        return;
      }
      sendSaitenData(null, null);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "前の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.prev_sheet_field);
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "次の設問へ移動します。よろしいですか？")){
        return;
      }
      await sendSaitenData(Number(state.sheet_id), state.next_sheet_field);
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = async () => {
      blur();
      const msg = state.is_last_room ? "先頭の教室に戻ります。よろしいですか？" : "次の教室へ移動します。よろしいですか？";
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, msg)){
        return;
      }
      sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field);
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "前の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field);
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_input/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isProcessingApi = true;

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}.png`, x.base64Canvas, {base64: true});
        }

        if(x.isTextEdited){
          x.tensakuTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`tensaku_text_${y.field_activity_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
        const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache).map(x => x.id);
        const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
        const tensakuUpdatedIds = state.fieldActivities.filter(x => x.isTextEdited).map(x => x.id);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("scoring_type", `${state.currentSheetField.scoring_type}`);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));
        fd.append("tensaku_updated_ids", JSON.stringify(tensakuUpdatedIds));

        await http.post(`/api/teacher/saiten_input/update/${state.sheet_id}`, fd).then(async response => {
          if(next_sheet_id != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_seigo/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
              context.root.$nextTick(() => {
                state.isLoaded = false;
                initialize();
              });
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
            }
          }else{
            // 採点一覧へ戻る
            context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
          }
        })
        .catch(async error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async (isMounted: boolean = false) => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      await http.get(`/api/teacher/saiten_input/check_saiten_lock/${state.sheet_field_id}`).then(response => {
        confirmMessage = response.data.confirm_message;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!window.confirm(confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      const param = {
        target_examinee_ids: context.root.$store.state.saitenTargetExamineeIds,
        sheet_id: state.sheet_id,
        sheet_field_id: state.sheet_field_id,
      };
      
      await http.post(`/api/teacher/saiten_input/search_init_data`, param).then(response => {

        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any, i: number) => new FieldActivity(x, response.data.sheet_activities, response.data.examinees, response.data.base64_canvas_hash_array, response.data.tensaku_texts, i + 1));
        
        state.base64CorrectImage = response.data.base64_correct_image;
        state.prev_sheet_field = response.data.prev_sheet_field;
        state.next_sheet_field = response.data.next_sheet_field;
        state.warningDispTime = Date.now() + response.data.warning_disp_time;
        state.selectedIdx = 0;
        state.processingTime = 0;

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = 1; i < state.currentSheetField.allot; i++){
          state.scoreOptions.push({value: i, text: `${i}点`});
        }

        // 部分点プルダウン初期選択値設定
        if(state.scoreOptions.length > 0){
          state.selectedScore = state.scoreOptions[0].value;
          state.isTokutenModeDisabled = false;
        }else{
          // 部分点選択不可の場合はボタン・プルダウン非活性
          state.isTokutenModeDisabled = true;
          if(state.drawMode == DrawModeEnum.TokutenClick){
            state.drawMode = DrawModeEnum.KeyInput;
          }
        }

        // 数字入力プルダウン生成
        state.tensakuNumberOptions = new Array<any>();
        for(let i = -100; i < 101; i++){
          state.tensakuNumberOptions.push({value: i, text: `${i}`});
        }

        // フォントサイズプルダウン生成
        state.fontSizeOptions = new Array<any>();
        for(let i = 5; i < 101; i++){
          state.fontSizeOptions.push({value: i, text: i});
        }

        // １行あたりの画像表示数設定 横長：6画像 縦長：15画像
        if(!state.isColCountChanged){
          if(state.currentSheetField.baseWidth > state.currentSheetField.baseHeight){
            state.colCount = 6;
          }else{
            state.colCount = 15;
          }
        }
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `レポート情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if(!state.isWindowEventAdded){
        window.addEventListener("keydown", keyDown);
        window.addEventListener("keyup", keyUp);
        window.addEventListener("resize", adjustLayout);
      }

      if(isMounted){
        state.direction = state.currentSheetField.baseWidth > state.currentSheetField.baseHeight ? DirectionEnum.Horizon : DirectionEnum.Vertical;
      }

      state.isLoaded = true;
      adjustLayout();
      context.root.$nextTick(() => {
        const verticalSaitenBoxAreaWidth = state.mainAreaWidth - state.separatorSize - (state.mainAreaWidth * state.verticalLeftWidthPer);
        state.verticalRightWidthPer = verticalSaitenBoxAreaWidth / state.mainAreaWidth;
        const horizonSaitenBoxAreaHeight = state.mainAreaHeight - state.separatorSize - (state.mainAreaHeight * state.horizonTopHeightPer);
        state.horizonBottomHeightPer = horizonSaitenBoxAreaHeight / state.mainAreaHeight;
        const saitenBoxArea = document.getElementById("saiten-box-area");
        state.scrollBarSize = saitenBoxArea.offsetWidth - saitenBoxArea.clientWidth;
        setCorrectImageScale();
      });
      state.processingTime = 0;
      state.isShowSessionMsg = false;
      state.isWarningTimeReached = false;
      state.timer = setInterval(() => {
        state.processingTime++;
        if(!state.isWarningTimeReached && Date.now() >= state.warningDispTime){
          state.isShowSessionMsg = true;
          state.isWarningTimeReached = true;
        }
      }, 1000);

      context.root.$nextTick(() => {
        if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
          // 採点済みデータありの場合は○×順表示で表示
          changeSortKind(SaitenSortKindEnum.CorrectState);
        }else{
          // 全件未採点の場合は番号順で表示
          changeSortKind(SaitenSortKindEnum.No);
        }
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      // 認識コンポーネント初期化
      recogSidebarRef.value.initialize();

      state.isProcessingApi = false;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 切り出し画像Base64文字列をセット
     ************************************************************/

    const setBase64Image = (idx: number, base64Image: string) => {
      state.fieldActivities[idx].base64Image = base64Image;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上をクリック
     ************************************************************/

    const fieldClicked = async (idx: number, clickedTensakuText: TensakuText) => {
      state.selectedIdx = idx;
      changeSelectedTensakuText(clickedTensakuText);
      
      if(state.drawMode == DrawModeEnum.SeitouClick){
        setCorrect(CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(state.drawMode == DrawModeEnum.GotouClick){
        setCorrect(CorrectStateEnum.Gotou, 0);
      }else if(state.drawMode == DrawModeEnum.TokutenClick){
        setCorrect(CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上フリックによる採点
     ************************************************************/
    
    const setCorrectByChild = async (idx: number, correctState: number) => {
      state.selectedIdx = idx;
      
      if(correctState == CorrectStateEnum.Seitou){
        setCorrect(CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(correctState == CorrectStateEnum.Gotou){
        setCorrect(CorrectStateEnum.Gotou, 0);
      }else if(correctState == CorrectStateEnum.Tokuten){
        // 部分点不可の設問で部分点フリックはリターン
        if(state.isTokutenModeDisabled){
          return;
        }
        setCorrect(CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      if(context.root.$store.state.fontSize != null){
        state.fontSize = context.root.$store.state.fontSize;
      }

      if(context.root.$store.state.lineHeight != null){
        state.lineHeight = context.root.$store.state.lineHeight;
      }

      await initialize(true);
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("resize", adjustLayout);
      if(state.allowResetSaitenLock){
        await http.post(`/api/teacher/saiten_input/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    /************************************************************
     * 文字認識サイドバー表示
     ************************************************************/
    
     const showRecogSidebar = (tabNo: number) => {
      recogSidebarRef.value.tabNo = tabNo;
      state.isRecogSidebarVisible = true;
    }

    /************************************************************
     * 文字認識実行
     ************************************************************/

    const recogExecute = async (param: any) => {
      state.isRecogOverlay = true;
      context.root.$store.dispatch("showOverlay");

      state.cancelToken = axios.CancelToken.source();

      await http.post(`/api/teacher/saiten_input/recog/${state.sheet_id}/${state.sheet_field_id}`, param, {
        cancelToken: state.cancelToken.token
      }).then(response => {
        let recog_correct_text = param["recog_correct_text"];
        
        if(param["is_recog_correct_image"] && response.data.correct_result != null){
          if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
            recog_correct_text = Common.getCorrectText(param["recog_type"], response.data.correct_result.recog_text);
          }else{
            recog_correct_text = response.data.correct_result.recog_text;
          }
          state.currentSheetField.recog_correct_text = recog_correct_text;
        }
        const results: any[] = response.data.results
        results.forEach(result => {
          const fieldActivity = state.fieldActivities.filter(x => x.id == result.field_activity_id)[0];
          fieldActivity.recog_text = result.recog_text;
          fieldActivity.confidence = result.confidence;
          fieldActivity.recog_errors = result.errors;

          // 正答が設定されている場合は正誤判定
          let correct_state: number = null;
          if(recog_correct_text != null){
            if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
              correct_state = recog_correct_text.includes(result.recog_text) ? CorrectStateEnum.Seitou : CorrectStateEnum.Gotou;;
            }else{
              correct_state = result.recog_text == recog_correct_text ? CorrectStateEnum.Seitou : CorrectStateEnum.Gotou;
            }
            const score = correct_state == CorrectStateEnum.Seitou ? state.currentSheetField.allot : 0;
            state.selectedIdx = state.fieldActivities.indexOf(fieldActivity);
            setCorrect(correct_state, score);
          }

          if(param["recog_type"] == Common.RecogTypeEnum.Math && result.recog_text != null){
            // 数式の場合はLaTexからSVGに変換
            fieldActivity.svgContent = Common.convertSvgElementByLaTex(result.recog_text);
          }else{
            fieldActivity.svgContent = null;
          }
        });

        // Common.showToast(context.root.$bvToast, "認識処理が完了しました。");
        state.isRecogSidebarVisible = false;
        changeSortKind(SaitenSortKindEnum.CorrectState)
      })
      .catch(error=>{
        state.isRecogOverlay = false;
        context.root.$store.dispatch("hideOverlay");
        if(axios.isCancel(error)){
          console.log(error);
        }else if(error.response && error.response.status == 422){
          recogSidebarRef.value.errors = error.response.data.errors;
        }else{
          recogSidebarRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      state.isRecogOverlay = false;
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 文字認識キャンセル
     ************************************************************/

    const recogCancel = () => {
      if(state.cancelToken){
        state.cancelToken.cancel('Operation canceled by the user.');
      }
    }

    /************************************************************
     * 編集した認識文字列で正誤判定
     ************************************************************/

    const recogByText = async (param: any) => {

      await http.post(`/api/teacher/saiten_input/update_recog_result/${state.sheet_id}/${state.sheet_field_id}`, param).then(response => {
        const selectedIdxCache = state.selectedIdx;
        for(const field_activity_id of param["param_field_activities"].map((x: any) => x["id"])){
          const fieldActivity = state.fieldActivities.filter(x => x.id == field_activity_id)[0];
          let correct_state: number = null;
          if(param["recog_correct_text"] != null){
            if(param["recog_type"] == Common.RecogTypeEnum.SingleAlpha){
              correct_state = param["recog_correct_text"].includes(fieldActivity.recog_text) ? Common.CorrectStateEnum.Seitou : Common.CorrectStateEnum.Gotou;
            }else{
              correct_state = fieldActivity.recog_text == param["recog_correct_text"] ? Common.CorrectStateEnum.Seitou : Common.CorrectStateEnum.Gotou;
            }
            const score = correct_state == Common.CorrectStateEnum.Seitou ? state.currentSheetField.allot : 0;
            state.selectedIdx = state.fieldActivities.indexOf(fieldActivity);
            setCorrect(correct_state, score);
          }

          if(state.currentSheetField.recog_type == Common.RecogTypeEnum.Math && fieldActivity.recog_text != null){
            // 数式の場合はLaTexからSVGに変換
            fieldActivity.svgContent = Common.convertSvgElementByLaTex(fieldActivity.recog_text);
          }else{
            fieldActivity.svgContent = null;
          }
        }
        state.selectedIdx = selectedIdxCache;
      })
      .catch(error=>{
        state.isRecogOverlay = false;
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          recogSidebarRef.value.errors = error.response.data.errors;
        }else{
          recogSidebarRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 認識結果編集
     ************************************************************/

    const recogTextChanged = (field_activity_id: number, recog_text: string) => {
      const fieldActivity = state.fieldActivities.filter(x => x.id == field_activity_id)[0];
      fieldActivity.recog_text = recog_text;
      if(state.currentSheetField.recog_type == Common.RecogTypeEnum.Math && fieldActivity.recog_text){
        // 数式の場合はLaTexからSVGに変換
        fieldActivity.svgContent = Common.convertSvgElementByLaTex(fieldActivity.recog_text);
      }else{
        fieldActivity.svgContent = null;
      }
    }

    return {
      ...toRefs(state),
      DrawModeEnum,
      SaitenSortKindEnum,
      CorrectStateEnum,
      DirectionEnum,
      SheetTypeEnum,
      saitenBoxRef,
      modalCorrectImageRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      popoverNumTextRef,
      previewImageSidebarRef,
      recogSidebarRef,
      changeColCount,
      setBase64Image,
      fieldClicked,
      showPreviewImage,
      setCorrectByChild,
      changeSaitenMode,
      changeSortKind,
      allCorrectChange,
      clearCorrect,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      showModalCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      changeSaitenModeBySaitenBox,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      changeDirection,
      saitenBoxAreaHeight,
      saitenBoxAreaWidth,
      correctImageStyle,
      setCorrectImageScale,
      changeRow,
      selectedTensakuTextElemId,
      changeSelectedTensakuText,
      changeText,
      textFormatChanged,
      addTensakuText,
      deleteTensakuText,
      showRecogSidebar,
      recogExecute,
      recogCancel,
      recogByText,
      recogTextChanged,
    };
  }
});
